import type { Ref } from "react";

interface AsciiModelFallbackProps {
	src: string;
	imageRef?: Ref<HTMLImageElement>;
}

export function AsciiModelFallback({ src, imageRef }: AsciiModelFallbackProps) {
	const fallbackSrc = src.replace(/\.[^.]+$/, "-ascii.png");

	return (
		<img
			ref={imageRef}
			alt=""
			aria-hidden="true"
			className="ascii-model-fallback absolute opacity-70 transition-opacity duration-300 lg:opacity-80"
			decoding="sync"
			fetchPriority="high"
			height="512"
			src={fallbackSrc}
			width="503"
		/>
	);
}
